import React from 'react';
import FadeIn from '../common/FadeIn';

const ServiceHeroSection = () => {
  return (
    <section className="w-full bg-[#f9f9f5] md:p-15 p-10 text-[#1C1917] text-center">
      <div className="max-w-[966px] mx-auto">
        <FadeIn>
          <span className="font-interDisplayMedium leading-[1.4] tracking-[0.5em] text-[10px] md:text-[14px] font-normal mb-3 md:mb-6 block">
            WEBSITE DEVELOPMENT
          </span>
        </FadeIn>

        <FadeIn>
          <h1 className="font-saolDisplayItalic leading-[1.1] tracking-[0em] text-[26px] md:text-[56px] font-normal mb-3 md:mb-6">
            A WEBSITE THAT FEELS<br />
            LIKE YOUR <span className="font-paraDisplayItalic italic lowercase tracking-normal text-[#3B342C] font-normal">business</span>
          </h1>
        </FadeIn>

        <FadeIn>
          <p className="font-interDisplayMedium leading-[1.5] tracking-[0em] text-[13px] md:text-[15px] max-w-[560px] mx-auto">
            I customize professionally designed websites with your content, images, branding, and style—giving you a clean, polished online presence without the cost or time of starting from scratch.
          </p>
        </FadeIn>
      </div>
    </section>
  );
};

export default ServiceHeroSection;
